import * as React from 'react';
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
import {TabPanel} from "../../../components/other/tabPanel";
import ServiceHL7 from "./service_hl7";
import Hl7Console from "./hl7_console";
import {StyledTabs, StyledTab} from "../admin";
import Hl7inMessages from "./hl7_incoming_mess";
import {Button, FormControlLabel, Switch} from "@mui/material";
import Hl7outMessages from "./hl7_outgoing_mess";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {FilterIcon} from "../../../components/icons/icons";
import {styled} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#448FFF"
    },
    switch_base: {
        "&.Mui-checked": {
            color: "#448FFF"
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#448FFF",
        }
    },
}));

function HL7Dashboard(props) {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [filterHidden, setFiltersHidden] = React.useState(false);

    const handleHideFilters = (e) => {
        setFiltersHidden(e.target.checked);
        e.stopPropagation();
    }

    const [liveMessage, setLiveMessage] = React.useState(true);

    const handleLive = (e) => {
        setLiveMessage(e.target.checked);
        e.stopPropagation();
    }

    const switchVisible = () => {
        return value === 0 || value === 1;
    }
    return (<Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider',display: "flex" }}>
            <StyledTabs value={value} onChange={handleChange} aria-label="basic tabs example" TabIndicatorProps={{className: classes.indicator}}>
                <StyledTab value={0} label="Incoming Message" />
                <StyledTab value={1} label="Outgoing Message" />
                <StyledTab value={2} label="Service control" />
                <StyledTab value={3} label="Test console" />
            </StyledTabs>
            {switchVisible() &&
            <div style={{    display: "inline-flex", alignItems: "center"}}>
                <div style={{display: "flex"}}><FormControlLabel
                    control={
                        <Switch classes={{switchBase: classes.switch_base}} checked={filterHidden} size="small" onChange={handleHideFilters}/>}
                    label={"Hide Filters "}/></div>
                <div style={{display: "flex"}}><FormControlLabel
                    control={
                        <Switch classes={{switchBase: classes.switch_base}} checked={liveMessage} size="small" onChange={handleLive}/>}
                    label={"Live"}/></div>
            </div>
            }

        </Box>
        <TabPanel value={value} index={0}>
            <Hl7inMessages filterHidden = {filterHidden} liveMessage={liveMessage} />
        </TabPanel>
        <TabPanel value={value} index={1}>
            <Hl7outMessages filterHidden = {filterHidden} liveMessage={liveMessage}/>
        </TabPanel>
        <TabPanel value={value} index={2}>
            <ServiceHL7/>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Hl7Console/>
        </TabPanel>
    </Box>)
}

export default HL7Dashboard;